import { DataTypeOption } from '../components/fields/FieldsSettings/FieldsSettingsTypes';

// Get data type-specific configuration
export const getConfigByDataType = (dataType?: string, dataFormat?: DataTypeOption | null) => {
  if (dataType === 'date') return { order: dataFormat?.order };
  if (['amount', 'number'].includes(dataType as string)) {
    const config: { decimalSymbol?: string; thousandsGrouping?: string } = {
      decimalSymbol: dataFormat?.decimalSymbol,
    };
    if (dataFormat?.thousandsGrouping !== undefined) {
      config.thousandsGrouping = dataFormat.thousandsGrouping;
    }
    return config;
  }
  return {};
};
